import { useCallback, useEffect, useMemo, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { getModulosPorUsuario } from '../componentes/http/actions/ModuloAction';

// Caché compartida: Sidebar, Inicio y buscador piden los módulos una sola vez por usuario.
let cache = { oid: null, promesa: null, datos: null };

const leerSesion = () => {
  try {
    const decoded = jwtDecode(localStorage.getItem('token'));
    return { rol: decoded.rol || '', oid: decoded.oid || null };
  } catch {
    return { rol: '', oid: null };
  }
};

const cargarModulos = (oid) => {
  if (cache.oid !== oid || !cache.promesa) {
    cache = {
      oid,
      datos: null,
      promesa: getModulosPorUsuario(localStorage.getItem('token'), oid)
        .then((res) => (Array.isArray(res) ? res : []))
        .catch((error) => {
          console.error('Error fetching servicios:', error);
          cache.promesa = null; // permite reintentar en el próximo montaje
          return [];
        }),
    };
  }
  return cache.promesa;
};

// Módulos contratados por el cliente del usuario (solo aplica al rol Usuario).
export const useModulosUsuario = () => {
  const { rol, oid } = useMemo(leerSesion, []);
  const enCache = cache.oid === oid && cache.datos;
  const [servicios, setServicios] = useState(enCache ? cache.datos : []);
  const [cargando, setCargando] = useState(rol === 'Usuario' && !enCache);

  useEffect(() => {
    if (rol !== 'Usuario' || !oid) {
      setCargando(false);
      return undefined;
    }
    let vigente = true;
    cargarModulos(oid).then((datos) => {
      if (cache.oid === oid) cache.datos = datos;
      if (vigente) {
        setServicios(datos);
        setCargando(false);
      }
    });
    return () => { vigente = false; };
  }, [rol, oid]);

  const tieneServicio = useCallback(
    (nombre) => servicios.some((s) => s.servicio?.toLowerCase().includes(nombre.toLowerCase())),
    [servicios]
  );

  return { rol, servicios, cargando, tieneServicio };
};
